const ru: Record<string, string> = {
  'nav.home': 'Главная',
  'nav.practice': 'Практика',
  'nav.copy': 'Копирование',
  'nav.recall': 'Воспроизведение',
  'nav.free': 'Свободное письмо',
  'nav.exam': 'Экзамен',
  'nav.library': 'Библиотека',
  'nav.history': 'История',
  'nav.progress': 'Прогресс',
  'nav.shared': 'Мне поделились',
  'nav.settings': 'Настройки',
  'nav.admin': 'Администрирование',
  'nav.menu': 'Меню',
};
const en: Record<string, string> = {
  'nav.home': 'Home',
  'nav.practice': 'Practice',
  'nav.copy': 'Copy',
  'nav.recall': 'Recall',
  'nav.free': 'Free writing',
  'nav.exam': 'Exam',
  'nav.library': 'Library',
  'nav.history': 'History',
  'nav.progress': 'Progress',
  'nav.shared': 'Shared with me',
  'nav.settings': 'Settings',
  'nav.admin': 'Admin',
  'nav.menu': 'Menu',
};
export default { ru, en };
